import BaseModel from './BaseModel'
import Location from '../models/Location'
import handleAxiosError from '../utils/handleAxiosError'

/**
 * @todo Add types for API methods.
 */
export default class LocationSolution extends BaseModel {

  static entity = 'location_solutions'
  static primaryKey = 'locationID'

  declare locationID: number
  declare universalInventory: boolean
  declare rateManagement: boolean
  declare blackouts: boolean
  declare reporting: boolean
  declare rateParity: boolean
  declare maxCapacity: boolean
  declare uri: boolean
  declare location: Location

  static fields() {
    return {

      locationID: this.number(null),
      universalInventory: this.boolean(false),
      rateManagement: this.boolean(false),
      blackouts: this.boolean(false),
      reporting: this.boolean(false),
      rateParity: this.boolean(false),
      maxCapacity: this.boolean(false),
      uri: this.boolean(false),

      // relationships
      location: this.belongsTo(Location, 'locationID')

    }
  }

  /**
   * API integrations
   */

  static fetchByLocationID(locationID: number) {
    return this.api()
      .get('/locations/' + locationID + '/location_solutions')
      .catch(handleAxiosError)
  }

  static saveExisting(payload: any) {
    return this.api()
      .put('/locations/location/' + payload.locationID + '/location_solutions', payload, {
        dataTransformer: ({ data }) => {
          data.locationID = payload.locationID
          return data
        }
      })
      .catch(handleAxiosError)
  }

}
